import { ReactNode } from 'react';
import cx from 'clsx';
import * as styles from './Items.css';

type ItemsProps = { children: ReactNode; label: ReactNode };
export function Items({ children, label }: ItemsProps): ReactNode {
  return (
    <div className={styles.itemsContainer}>
      <div className={styles.label}>{label}</div>
      <div className={styles.collectionContainer} tabIndex={0} role="listbox">
        {children}
      </div>
    </div>
  );
}

type ItemProps = {
  children: ReactNode;
  selected?: boolean;
  onSelect?: () => void;
  className?: string;
  testId?: string;
};

export function Item({ children, selected, onSelect, className, testId }: ItemProps): ReactNode {
  return (
    <div
      className={cx(styles.itemContainer, className, { selected })}
      data-testid={testId}
      onClick={onSelect}
      role="option"
      aria-selected={selected}
    >
      {children}
    </div>
  );
}
